import { hasSegmentInPath } from "../url/has-segment-in-path";

/**
 * URL path segments that force noindex/nofollow metadata and sitemap exclusion,
 * overriding any Sanity setting for pages whose resolved path contains one of
 * these segments.
 *
 * Adding to this list extends the behavior automatically. No call-site changes
 * are required, but the matching field descriptions in the Sanity schemas
 * (`noIndex`, `noFollow`, `hideFromSitemap`) should be updated to list the new
 * segment alongside the existing ones.
 *
 * Promoted from `apps/hi-www/src/lib/seo/has-restricted-segment.ts` so that
 * hi-www, hi-care, the Segment client beacon, and the synthetic SEO crawler
 * all consume the same source of truth. Adding `"staging"` or similar here
 * automatically extends both code-level enforcement and monitoring coverage.
 */
const RESTRICTED_URL_SEGMENTS: readonly string[] = ["ppc"];

/**
 * Returns true when the pathname has a segment exactly matching one of the
 * configured restricted segments. Matching is case-sensitive because Sanity
 * slugs are always lowercase.
 */
function hasRestrictedSegment(pathname: string | undefined | null): boolean {
  return hasSegmentInPath(pathname, RESTRICTED_URL_SEGMENTS);
}

export { hasRestrictedSegment, RESTRICTED_URL_SEGMENTS };
